// src/shared.js
var isClient = typeof window !== "undefined";
var _window = isClient ? window : void 0;

export { _window, isClient };
